// メッセージ種類
const MSG_TYPE = {
  COMPLETE: 0, //決済完了
  RETRY: 1, //決済再挑戦
  REFUND_OK: 2, //払い戻しOK(内部エラー)
  REFUND_OK_ORDER_NOT_ACCEPTED: 5, //払い戻しOK(チェックエラー)
  REFUND_NG: 4, //払戻NG(重大なエラー)
  // 未使用
  REFUND_OK_AFTER_NG: 3, //払戻OK(後処理NG)
  REFUND_OK_SOLDOUT: 6, //払戻OK(売切商品あり)
  // 予期せぬエラー
  SERIOUS: 99, //重大なエラー
};

// 支払フロー処理結果
const PAY_TYPE = {
  INVALID: 0,
  REQ_OK: 1,
  REQ_NG: 2,
  CONFIRM_BEFORE_NG: 3,
  CONFIRM_OK: 4,
  CONFIRM_OK_REFUND_OK: 5,
  CONFIRM_OK_REFUND_OK_AFTER_NG: 6,
  CONFIRM_OK_REFUND_NG: 7,
  CONFIRM_NG: 8,
  CONFIRM_OK_ORDER_NOT_ACCEPTED_REFUND_OK: 9,
  CONFIRM_OK_SOLDOUT_REFUND_OK: 10,
  CONFIRM_OK_SERIOUS: 99,
};

const ERR_MESSAGES = [
  // 予期せぬエラー
  {
    type: MSG_TYPE.SERIOUS,
    title: "重大なエラーが発生しました",
    text: "大変申し訳ございませんが、お店までご連絡をお願いします。",
  },
  // 再決済を促す
  {
    type: MSG_TYPE.RETRY,
    title: "決済時にエラーが発生しました",
    text:
      "大変申し訳ございませんが、トーク画面へ戻り、再度お支払い処理をお願いいたします。",
  },
  // 払い戻し成功(注文受付不可)
  {
    type: MSG_TYPE.REFUND_OK_ORDER_NOT_ACCEPTED,
    title: "注文をお受けすることができません",
    text: "決済完了しましたが、現在注文をお受けすることができませんので、払い戻しを行いました。",
  },
  // 払い戻し成功(売切商品あり)
  {
    type: MSG_TYPE.REFUND_OK_SOLDOUT,
    title: "販売できない商品があります",
    text:
      "大変申し訳ございません。決済完了しましたが、販売できない商品が含まれていたため、払い戻しを行いました。",
  },
  // 払い戻し成功
  {
    type: MSG_TYPE.REFUND_OK,
    title: "決済後にエラーが発生しました",
    text:
      "決済完了しましたが、内部エラーが発生したため払い戻しを行いました。大変申し訳ございませんが、トーク画面に戻って再度「決済」ボタンを押してください。",
  },
  // 払い戻し成功->後処理失敗
  {
    type: MSG_TYPE.REFUND_OK_AFTER_NG,
    title: "決済後にエラーが発生しました",
    text:
      "決済完了しましたが、内部エラーが発生したため払い戻しを行いました。システム復旧のため、しばらくお待ちください。",
  },
  // 払い戻し失敗
  {
    type: MSG_TYPE.REFUND_NG,
    title: "決済後にエラーが発生しました",
    text:
      "決済完了しましたが、内部エラーが発生しました。払い戻しにも失敗したため、大変申し訳ございませんが、お店に連絡をして直接払い戻しするようご連絡をお願いします。",
  },
];
const MESSAGE_DEFAULT = ERR_MESSAGES[0];

class PayError {
  constructor() { }

  findMessage (msgType) {
    const message = ERR_MESSAGES.find((message) => {
      return message.type == msgType;
    });
    if (!message) {
      return MESSAGE_DEFAULT;
    }
    return message;
  }
}
const payError = new PayError();

export { MSG_TYPE, payError, PAY_TYPE, ERR_MESSAGES };
